import React, { useEffect } from 'react';

import { useTimer } from '../context/TimerContext';

import { usePageControl } from '../context/PageControlContext';

import { Link } from "react-router-dom";

import MetPolicelogo from '../assets/images/met-police-logo-outlined.svg';
import cog from '../assets/images/cog.svg';

function Home() {

// Timer
const { timeRemaining, formatTime, isRunning, initialiseGame } = useTimer();

// when Home mounts, always reload the latest admin-set duration
  useEffect(() => {
    initialiseGame();
  }, [initialiseGame]);

// Determine additional classes dynamically
  let additionalClasses = '';
  if (isRunning) {
    additionalClasses += ' timer-running';
  }
  if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
    additionalClasses += ' timer-warning';
  }
  if (timeRemaining < 0) { // time exceeded
    additionalClasses += ' timer-exceeded';
  }

  // For button navigation
  const { goNext } = usePageControl();

  return (
    <div id="home" className="physical">

    {/* -- Background animation -- */}
    {/* <div id="anim-dots-1" className="anim-dots"></div>
    <div id="anim-dots-2" className="anim-dots"></div>
    <div id="anim-dots-3" className="anim-dots"></div>
    <div id="anim-dots-4" className="anim-dots"></div>
    <div id="anim-dots-5" className="anim-dots"></div>
    <div id="anim-dots-6" className="anim-dots"></div> */}
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  {/*<div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>*/}
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div id="box-wrapper-1">
                      <img src={MetPolicelogo} className="met-police-logo img-fluid" alt="Metropolitan Police logo"/>
                      <h1>Cyber Escape Room</h1>
                      <a
                        className="btn btn-home btn-pulse"
                        onClick={() => {
                          initialiseGame();
                          goNext();
                        }}
                      >
                        Start
                      </a>
                    </div>
                </div>
            </div>
            <Link to="app-admin" id="admin-link"><img src={cog} alt="Admin icon"/></Link>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    
                </div>
            </div>
        </footer>
    
    </div>
  );
}

export default Home;
